import { render, staticRenderFns } from "./IristarSwzy.vue?vue&type=template&id=0766681b&scoped=true&"
import script from "./IristarSwzy.vue?vue&type=script&lang=js&"
export * from "./IristarSwzy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0766681b",
  null
  
)

export default component.exports